<template>
  <div class="column is-9">
    <div v-if="isLoading" class="loading">
      <pulse-loader :loading="isLoading"></pulse-loader>
    </div>
    <div v-else-if="topic && !isLoading" class="is-border is-radius-large has-bg-white content content-guide">
      <div class="column is-border-bottom is-paddingless-bottom">
        <h1>{{ topicTitle }}</h1>
        <!-- <a class="editBtn" v-bind:href="cmsPath+'/wp-admin/post.php?post='+topic.data.ID+'&action=edit'" target="_blank">edit page</a> -->
        <!--
        <span class="intro-guide-faq">{{ topicSummary }}</span>
        <div v-if="topicIllustration" class="media" style="text-align:center">
          <img :src="topicIllustration" style="text-align :center" :alt="page.data.title">
        </div>
        <br>
        -->
        <div class="column entry ">
          <div v-html="topicContent" class="entry-content"></div>
        </div>
      </div>
      <ul class="liste-themes-guide columns is-gapless is-multiline is-margin-bottom-large">
        <page-tile
          v-for="child in topic.data.childs" :key="child.slug" :topic="topic.data" :page="child"
        >
        </page-tile>
      </ul>
    </div>
  </div>
</template>

<script>
  import { api } from '../cmsApi'
  import { isNil } from 'lodash'
  import PulseLoader from '../components/PulseLoader'
  import PageTile from '../components/PageTile'

  export default {
    name: 'Topic',
    components: { PageTile, PulseLoader },
    data () {
      return {
        isLoading: false,
        topic: null,
        cmsPath: process.env.VUE_APP_CMS
      }
    },
    computed: {
      topicId () { // topicId () {
        return this.$route.params.topicId
      },

      topicTitle () {
        return this.topic.data.title
      },
      topicIllustration () { // TODO - img couv WP
        return this.topic.data.cover
      },
      topicContent () { // TODO exerpt WP Rest
        return this.topic.data.content
      },
      topicSummary () { // TODO exerpt WP Rest
        return this.topic.data.excerpt
      },
      topicChilds () { // TODO exerpt WP Rest
        return this.topic.data.childs
      }

    },
    watch: {
      $route: 'initComponent'
    },
    created () {
      this.initComponent()
    },
    methods: {
      async initComponent () {
        /*
        if (api.isInit === false) {
          await api.init()
        }
        this.isLoading = true
        let topic = await api.fetchByID(this.topicId)
        this.topic = topic


        if (topic.data.pages) {
          let pageIds = topic.data.pages.filter(x => isNil(x.page.id) === false).map(x => x.page.id)
          if (pageIds && pageIds.length > 0) {
            this.pages = await api.fetchByIDs(pageIds)
          }
        }

        this.isLoading = false
        */
        if (api.isInit === false) {
          await api.init()
        }
        this.isLoading = true
        // let page = await api.fetchByID(this.pageId)
        console.log('>>> fetchTopicPage('+this.topicId+')')
        let topic = await api.fetchPage(this.topicId)
        this.topic = topic
        this.isLoading = false
      }
    }
  }
</script>


<style lang="css" scoped>

  a.editBtn{ position:absolute;right:40px;top:30px; }

  .fade-enter-active, .fade-leave-active {
      transition: opacity .3s, transform .3s;
      transform: translateX(0px);
  }
  .fade-enter{
      opacity: 0;
      transform: translateX(-20px);
  }
  .fade-leave-to{
      opacity: 0;
      transform: translateX(40px);
  }

</style>
